import { createClasses } from "@bloomberg/media-ui-core";
import React from "react";
import styles from "./styles.module.css";
import { PortfolioFormHolding, PortfolioHolding } from "~types/portfolio";
import LotLine from "~components/Portfolio/PortfolioForm/LotLine";

type LotsRowProps = {
  holdingIndex: number;
  holding: PortfolioFormHolding;
};

export default function LotsRow(props: LotsRowProps) {
  const { holdingIndex, holding } = props;

  return (
    <>
      <div className={styles.row}>
        <div
          className={createClasses(
            styles.cell,
            styles.noBottomPadding,
            styles.cellFixed
          )}
        >
          <span className={styles.columnHeading} />
        </div>
        <div className={createClasses(styles.cell, styles.noBottomPadding)}>
          <span className={styles.columnHeading}>Date</span>
        </div>
        <div className={createClasses(styles.cell, styles.noBottomPadding)}>
          <span className={styles.columnHeading}>Shares</span>
        </div>
        <div className={createClasses(styles.cell, styles.noBottomPadding)}>
          <span className={styles.columnHeading}>Price</span>
        </div>
      </div>
      {holding.lots.map((lot: PortfolioHolding, lotIndex: number) => (
        <LotLine
          key={lotIndex}
          index={lotIndex}
          holdingIndex={holdingIndex}
          lotData={lot}
        />
      ))}
    </>
  );
}
